import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-w-[330px] mx-auto mt-8 pt-16 flex flex-col items-center justify-center" }
const _hoisted_2 = { class: "text-xl mt-2" }

import { IonIcon, IonPage, IonContent } from '@ionic/vue'
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'
import { useGWAnalytics } from '@/plugins/analytics'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const { vAnalyticsClick } = useGWAnalytics()
const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { class: "![--offset-top:0px]" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonIcon), {
              src: require('@/assets/x-circle.svg'),
              class: "gw-main-icon text-[3.125rem] rounded-md text-primary"
            }, null, 8, ["src"]),
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)('page_not_found')), 1),
            _withDirectives((_openBlock(), _createElementBlock("a", {
              class: "text-grey hover:text-primary py-3 mt-4",
              href: "#",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).push('/')), ["prevent"]))
            }, [
              _createTextVNode(_toDisplayString(_unref(t)('back_to_order')), 1)
            ])), [
              [_unref(vAnalyticsClick), _unref(route)]
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})